<template>
  <v-list-tile avatar>
    <v-layout>
      <v-flex xs2 md1>
        <v-list-tile-avatar class="pt-3">
          <v-icon :color="item.color">color_lens</v-icon>
        </v-list-tile-avatar>
      </v-flex>
      <v-flex xs5 sm4 lg3>
        <v-list-tile-content>
          <v-list-tile-title><span v-t="item.name" /></v-list-tile-title>
        </v-list-tile-content>
      </v-flex>
      <v-flex xs4 sm2>
        <v-list-tile-content>
          <v-text-field :value="item.hex" @input="$emit('newColor', $event)" />
        </v-list-tile-content>
      </v-flex>
    </v-layout>
  </v-list-tile>
</template>

<script>
export default {
  name: 'ColorRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      color: this.item.hex,
    };
  },
};
</script>
